import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./sideNav.module.css";
// import companyStore from "../../Store/Store";
// import { observer } from "mobx-react";
import axios from "axios";

const SideNav = ({ closeTabs, className = "" }) => {
  const navigate = useNavigate();
  const [isOwner, setsOwner] = useState(false);
  const location = useLocation();

  //   useEffect(() => {
  //     setsOwner(companyStore.isUserOwner);
  //   }, [companyStore.isUserOwner]);
  //   console.log("sideNav ", isOwner);

  const TransactionClick = useCallback(() => {
    navigate("/content/kyc");
    closeTabs();
  }, [navigate]);

  const TransactionClick2 = useCallback(() => {
    navigate("/content/acc-validation");
    closeTabs();
  }, [navigate]);

  const isActive = (path) => {
    if (path == location.pathname) {
      return true;
    }
    return false;
  };

  const NavigateToDashboard = async () => {
    console.log("inside NavigateToDashboard");

    const obj = {
      dashId: 5,
    };
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://insights.getcupi.com/node-api/dashboard-url`,
      headers: {
        "x-api-key": "c729eae6-27fc-4e44-9538-08187d5f4f4b",
        "Content-Type": "application/json",
      },
      data: obj,
    };
    console.log("invoking api");

    let response = await axios.request(payload);
    console.log("response", response.data.embedUrl);
    window.open(response.data.embedUrl, "_blank");
    // window.location.assign(response.data.embedUrl)
  };
  const isKycActive =
    location.pathname === "/content/kyc" ||
    location.pathname.startsWith("/content/kyc/");
  return (
    <div className={[styles.transaction, className].join(" ")}>
      <div>
        <div className={styles.finalCupiLogo}>
          <img className={styles.escrowLogo} alt="" src="/Final_Cupi.svg" />
        </div>
        <div className={styles.transactionParent}>
          <button
            className={
              isKycActive
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={TransactionClick}
          >
            <img
              className={styles.personVcardIcon}
              src={isKycActive ? "/kycicon(Active).svg" : "/kycIcon.svg"}
              alt=""
            />
            <div className={styles.userManagement}>KYC</div>
          </button>
          <button
            className={
              isActive("/content/acc-validation")
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={TransactionClick2}
          >
            <img
              className={styles.personVcardIcon}
              src={
                isActive("/content/acc-validation")
                  ? "/acc_config_active.svg"
                  : "/acc_config.svg"
              }
              alt=""
            />
            <div className={styles.userManagement}>A/c Validation</div>
          </button>
        </div>
      </div>
      {/* <div className={styles.finalCupiLogo1}>
        <img className={styles.escrowLogo} alt="" src="/PineLabsLogo.svg" />
      </div> */}
    </div>
  );
};

SideNav.propTypes = {
  className: PropTypes.string,
};

export default SideNav;
